import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { hasGlobalSession } from "../helpers/loginHelpers";
import { useUrlWithSearchParams } from "../helpers/routeHelpers";
import { useAppContext } from "../helpers/context-hooks/useAppContext";

export const PrivateRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const { state } = useAppContext();
  const redirect = useUrlWithSearchParams("/");

  if (hasGlobalSession(state)) {
    return <>{children}</>;
  }
  // Not authenticated, no bene, go to landing
  return <Navigate to={redirect} replace />;
};
